<template lang="pug">
AppPopover(
  ref="AppPopover"
  lazy
  :popover-container-classes="containerClasses"
  @click="close"
)
  span(slot="body")
    .time-entries-popover-content.vue-time-entries-weekly-list-popover
      .h5 Time entries
      .popover-time-entries
        .popover-time-entry(
          v-for="(timeEntry, index) in timeEntries"
          :key="`${timeEntry.start_time}-${timeEntry.stop_time}-${index}`"
        )
          | {{ formattedDatetimeRange(timeEntry.start_time, timeEntry.stop_time) }}
          i.fa.fa-dollar.a-tooltip.ml-5.mr-5(
            v-if="timeEntry.billable"
            v-tooltip="{ placement: 'right' }"
            title="Billable time"
          )
          TimeEntriesLockedPopover(
            v-if="showLocked(timeEntry)"
            trigger="hover"
            :reasons="timeEntry.allReasons"
          )
            .inline-block(slot="trigger")
              i.hi.hi-lock.ml-5
          .pull-right(v-else)
            a.action.text-danger.a-tooltip.pull-right.mr-5(
              :disabled="timeEntry.manual_time_request"
              data-container="body"
              @click="openDeleteDialog(timeEntry)"
            )
              i.hi.hi-bin.hi-14
            a.action.pull-right.mr-10(
              v-tooltip="{ placement: 'bottom', html: true }"
              :class="timeEntry.work_break ? 'ml-5' : ''"
              :disabled="timeEntry.editDisabled"
              data-container="body"
              :data-original-title="timeEntry.modifiableTooltip"
              @click="openEditDialog(timeEntry)"
            )
              i.hi.hi-edit.hi-14
            a.action.pull-right.mr-10(
              v-if="!timeEntry.work_break"
              v-tooltip="{ placement: 'bottom', html: true }"
              :disabled="timeEntry.editDisabled"
              data-container="body"
              :data-original-title="timeEntry.modifiableTooltip"
              @click="openSplitDialog(timeEntry)"
            )
              i.hi.hi-split.hi-14.text-success
      .row
        .col-xs-12.btn-container
          AppButton.btn-block.btn-sm(
            v-tooltip="{ placement: 'bottom' }"
            type="primary"
            :disabled="addDisabled"
            :title="addTimeDisabled"
            @click="openTimeEntriesFormDialog"
          ) Add time
  template(slot="trigger")
    slot(name="trigger")
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDatetimeRange } from '~/utils/time_utils';
// TODO (unlocking time): Use the popover for the cases where time can't get changed.
import TimeEntriesLockedPopover from '../TimeEntriesLockedPopover.vue';

export default {
  name: 'TimeEntriesWeeklyListPopover',
  components: {
    TimeEntriesLockedPopover,
  },
  props: {
    timeEntries: {
      type: Array,
    },
    addManualBreakEnabled: {
      type: Boolean,
      default: false,
    },
    workBreakPolicyId: {
      type: Number,
      default: null,
    },
    containerClasses: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['currentZone', 'addTimeDisabled', 'newTimeEntry', 'showLocked']),
    addDisabled() {
      const addTimeDisabled = !!this.addTimeDisabled;

      if (this.workBreakPolicyId) {
        return addTimeDisabled || !this.addManualBreakEnabled;
      }

      return addTimeDisabled;
    },
  },
  methods: {
    openTimeEntriesFormDialog() {
      if (!this.addDisabled) {
        const baseEntry = this.timeEntries[0];
        const timeEntry = Object.assign({}, this.newTimeEntry, {
          start_time: baseEntry.start_time,
          stop_time: baseEntry.start_time,
          project_id: baseEntry.project_id,
          task_id: baseEntry.task_id,
          work_break_policy_id: this.workBreakPolicyId,
        });

        this.$store.dispatch('openDialog', { dialog: 'timeEntriesFormDialog', type: 'add', timeEntry });
        this.close();
      }
    },
    formattedDatetimeRange(start, stop) {
      return formatDatetimeRange(start, stop, { style: 'time', showSeconds: 'auto', timezone: this.currentZone.name });
    },
    openEditDialog(timeEntry) {
      if (!timeEntry.editDisabled) {
        this.$store.dispatch('openDialog', { dialog: 'timeEntriesFormDialog', type: 'edit', timeEntry });
        this.close();
      }
    },
    openSplitDialog(timeEntry) {
      this.$store.dispatch('openDialog', { dialog: 'timeEntriesSplitDialog', timeEntry });
      this.close();
    },
    openDeleteDialog(timeEntry) {
      if (timeEntry.manual_time_request) {
        return;
      }

      this.$store.dispatch('openDialog', { dialog: 'timeEntriesDeleteDialog', timeEntry });
      this.close();
    },
    open() {
      this.$refs.AppPopover.open();
    },
    close() {
      this.$refs.AppPopover.close();
    },
  },
};
</script>
